import React, { FC } from "react";
import cn from "classnames";
import { Button } from "src/components/Button";
import Animation from "src/components/Animations";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as ArrowWhiteIcon } from "src/assets/icons/arrow-right-white-base.svg";
import { IPackege } from "./types";
import { useMediaQuery } from "react-responsive";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { SafeHTML } from "src/components/SafeHTML";

const EXPANDED_FLEX_GROW_FACTOR = 5;

const DELAY = 150;

interface Props {
  packege: IPackege;
  selectedPackageName: string;
  onClick: (name: string) => void;
}

export const PackegeItem: FC<Props> = ({
  packege: { id, name, image, content, price },
  selectedPackageName,
  onClick,
}) => {
  const isMDScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.MD,
  });

  const isActive = selectedPackageName === name;

  const buttonLabel = `${
    isMDScreenBreakpoint ? "" : "Вартість "
  }від ${price} грн.`;

  return (
    <article
      key={id}
      className={cn(
        "flex flex-col shrink basis-0 bg-white-base bg-no-repeat bg-cover bg-center pt-3 pl-3 xl:pt-7 xl:pl-7 rounded-15",
        {
          [image]: !isActive,
        }
      )}
      style={{
        flexGrow: isActive ? id + EXPANDED_FLEX_GROW_FACTOR : id,
      }}
    >
      <h5 className="text-18 md:text-24 text-green-base font-bold uppercase">
        {name}
      </h5>

      {isActive && (
        <Animation
          className="relative h-full overflow-hidden"
          variant="slide-right"
          delay={DELAY}
        >
          <SafeHTML
            html={content}
            className="flex flex-col text-8 sm:text-10 md:text-12 lg:text-14 xl:text-base lg:absolute top-0 [&_ul]:flex [&_ul]:flex-col [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1 [&_li]:leading-tight"
          />
        </Animation>
      )}

      {isActive ? (
        <Animation
          className="mt-auto self-end"
          variant="slide-right"
          delay={DELAY}
        >
          <Button className="mt-5" variant={ButtonVariants.GREEN}>
            <span>{buttonLabel}</span>
          </Button>
        </Animation>
      ) : (
        <Button
          className="mt-auto self-end rotate-90 lg:rotate-0"
          onClick={() => onClick(name)}
          variant={ButtonVariants.GREEN}
        >
          <ArrowWhiteIcon />
        </Button>
      )}
    </article>
  );
};
